export const FUELS = {
  electricity: {
    unit: "kwh",
    density: 1,
    calorificValueMJt: 1,
    mjToMwh: 0.001,
  },
  renewable_energies: {
    unit: "kwh",
    density: 1,
    calorificValueMJt: 1,
    mjToMwh: 0.001,
  },
  natural_gas: {
    unit: "m3",
    density: 0.7,
    calorificValueMJt: 48,
    mjToMwh: 0.000277778,
  },
  glp_l: {
    unit: "l",
    density: 0.54,
    calorificValueMJt: 47.3,
    mjToMwh: 0.000277778,
  },
  glp_kg: {
    unit: "kg",
    density: 1,
    calorificValueMJt: 47.3,
    mjToMwh: 0.000277778,
  },
  heavy_fuel_oil: {
    unit: "l",
    density: 1,
    calorificValueMJt: 1,
    mjToMwh: 0.000277778,
  },
  light_fuel_oil: {
    unit: "l",
    density: 1,
    calorificValueMJt: 1,
    mjToMwh: 0.000277778,
  },
  coal: {
    unit: "kg",
    density: 1,
    calorificValueMJt: 25.8,
    mjToMwh: 0.000277778,
  },
  diesel: {
    unit: "l",
    density: 0.84,
    calorificValueMJt: 43,
    mjToMwh: 0.000277778,
  },
  biodiesel: {
    unit: "l",
    density: 0.84,
    calorificValueMJt: 43,
    mjToMwh: 0.000277778,
  },
  gasoline: {
    unit: "l",
    density: 0.74,
    calorificValueMJt: 44.3,
    mjToMwh: 0.000277778,
  },
  biofuel: {
    unit: "l",
    density: 0.74,
    calorificValueMJt: 44.3,
    mjToMwh: 0.000277778,
  },
  biomass: {
    unit: "kg",
    density: 1,
    calorificValueMJt: 156,
    mjToMwh: 0.000277778,
  },
  steam: {
    unit: "kg_steam",
    density: 1,
    calorificValueMJt: 1,
    mjToMwh: 0.000277778,
  },
};

export const energyCodeToFuente = {
  electricity_standard_combined: "electricity",
  electricity_standard_domestic: "electricity",
  electricity_standard_production: "electricity",
  electricity_vehicles: "electricity",
  irec_certificates_kpis:"electricity",
  //electricity_cost_total: "electricity",

  renewable_energies_ppa_combined: "renewable_energies",
  renewable_energies_ppa_domestic: "renewable_energies",
  renewable_energies_ppa_production: "renewable_energies",
  //renewable_energies_ppa_cost: "renewable_energies",
  renewable_energies_ppa_domestic_kpis: "renewable_energies",
  renewable_energies_ppa_production_kpis: "renewable_energies",
  renewable_energies_on_site_combined_kpis: "renewable_energies",
  // renewable_energies_ppa_cost_kpis: "renewable_energies",
  renewable_energies_ppa_combined_kpis: "renewable_energies",

  renewable_energies_on_site_combined: "renewable_energies",
  renewable_energies_on_site_domestic: "renewable_energies",
  renewable_energies_on_site_production: "renewable_energies",
  //renewable_energies_on_site_maintenance_and_amortization: "renewable_energies",

  natural_gas_combined: "natural_gas",
  natural_gas_cogeneration: "natural_gas",
  natural_gas_production_operations: "natural_gas",
  natural_gas_domestic: "natural_gas",
  natural_gas: "natural_gas",
  _natural_gas: "natural_gas",

  glp_combined: "glp_l",
  glp_cogeneration: "glp_l",
  glp_production_operations: "glp_l",
  glp_domestic: "glp_l",
  glp: "glp_l",
  _glp: "glp_l",
  //glp_total_cost: "glp",

  heavy_fuel_oil_total: "heavy_fuel_oil",
  //heavy_fuel_oil_total_cost: "heavy_fuel_oil",

  light_fuel_oil_total: "light_fuel_oil",
  //light_fuel_oil_total_cost: "light_fuel_oil",

  coal_total: "coal",
  //coal_total_cost: "coal",

  diesel_combined: "diesel",
  diesel_cogeneration: "diesel",
  diesel_production_operations: "diesel",
  diesel_forklifts: "diesel",
  diesel: "diesel",
  _diesel: "diesel",
  //diesel_total_cost: "diesel",

  biodiesel_combined: "biodiesel",
  biodiesel_cogeneration: "biodiesel",
  biodiesel_production_operations: "biodiesel",
  biodiesel_forklifts: "biodiesel",
  biodiesel: "biodiesel",
  _biodiesel: "biodiesel",
  //biodiesel_total_cost: "biodiesel",

  gasoline_combined: "gasoline",
  gasoline_cogeneration: "gasoline",
  gasoline_production_operations: "gasoline",
  gasoline_forklifts: "gasoline",
  gasoline: "gasoline",
  _gasoline: "gasoline",
  //gasoline_total_cost: "gasoline",

  biofuel_combined: "biofuel",
  biofuel_cogeneration: "biofuel",
  biofuel_production_operations: "biofuel",
  biofuel_forklifts: "biofuel",
  //biofuel_total_cost: "biofuel",

  biomass_total: "biomass",
  //biomass_total_cost: "biomass",

  steam_total: "steam",
  //steam_total_cost: "steam",

  total_energy_kpis: "electricity",

  ethanol: "biofuel",
  _ethanol: "biofuel",
};

// ------------------------------------------
// 🔹 BUSCA FUENTE (exacta o parcial)
// ------------------------------------------
export function findEnergyFuente(code) {
  if (!code) return null;

  const lower = code?.toLowerCase();

  // Si es un campo de costo, no tiene fuente de energía para conversión
  if (lower.includes("_cost_") || lower.includes("cost_total") || lower.endsWith("_cost")) {
    return null;
  }

  // búsqueda exacta
  if (energyCodeToFuente[lower]) return energyCodeToFuente[lower];

  // búsqueda parcial (por includes) - solo para campos de consumo, no de costo
  const found = Object.entries(energyCodeToFuente).find(([key]) =>
    lower.includes(key.replace(/_kpis$/, ""))
  );

  return found ? found[1] : null;
}

// ---- Energy conversion factors relative to 1 MJ ----
const ENERGY_FACTORS = {
  j: 1e6, // 1 MJ = 1,000,000 J
  kj: 1e3, // 1 MJ = 1,000 kJ
  mj: 1, // base
  gj: 1 / 1000, // 1 GJ = 1000 MJ
  kwh: 1 / 3.6, // 1 kWh = 3.6 MJ
  mwh: 1 / 3600, // 1 MWh = 3600 MJ
  btu: 947.817 / 1e6, // 1 BTU = 0.000947817 MJ
  mmbtu: 947.817, // 1 MMBTU = 947.817 MJ
};

// 🔹 Factores de conversión según tabla de imágenes
// 🔹 Se usa el mismo factor para kg y litros por simplicidad
// Tabla 1: Conversión a MWh
export const CONVERSION_FACTORS_TO_MWH = {
  electricity: 0.00100, // 1 kwh = 0.001 Mwh
  renewable_energies: 0.00100,
  natural_gas: 0.00933, // 1 m3 = 0.00933 Mwh
  glp_l: 0.00710, // 1 unidad (L o kg) = 0.00710 Mwh
  glp_kg: 0.01314,
  heavy_fuel_oil: 0.01163, // 1 unidad = 0.01163 Mwh
  light_fuel_oil: 0.01214, // 1 unidad = 0.01214 Mwh
  coal: 0.00466, // 1 unidad = 0.00466 Mwh
  diesel: 0.01200, // 1 unidad = 0.01200 Mwh
  biodiesel: 0.012, // 1 unidad = 0.012 Mwh
  gasoline: 0.01239, // 1 unidad = 0.01239 Mwh
  biofuel: 0.01239, // 1 unidad = 0.01239 Mwh
  biomass: 0.00168, // 1 unidad = 0.00168 Mwh
  steam: 0.00069, // 1 unidad = 0.00069 Mwh
};

// Tabla 2: Conversión a KWh
const CONVERSION_FACTORS_TO_KWH = {
  electricity: 1, // 1 kwh = 1 Kwh (mismo)
  renewable_energies: 1,
  natural_gas: 9.33, // 1 m3 = 9.33 Kwh
  glp_l: 7.10, // 1 unidad (L o kg) = 7.10 Kwh
  glp_kg: 13.14,
  heavy_fuel_oil: 11.63, // 1 unidad = 11.63 Kwh
  light_fuel_oil: 12.14, // 1 unidad = 12.14 Kwh
  coal: 4.66, // 1 unidad = 4.66 Kwh
  diesel: 12.00, // 1 unidad = 12.00 Kwh
  biodiesel: 12.00, // 1 unidad = 12.00 Kwh
  gasoline: 12.39, // 1 unidad = 12.39 Kwh
  biofuel: 12.39, // 1 unidad = 12.39 Kwh
  biomass: 1.68, // 1 unidad = 1.68 Kwh
  steam: 0.69, // 1 unidad = 0.69 Kwh
};

// 🔹 IMPORTANTE: Interpretación correcta de los factores de conversión
// El ejemplo de la tabla muestra: 10,395 litros de gasolina → 839 KWh con factor 12.39
// Esto significa: 10,395 ÷ 12.39 = 839 KWh
// Por lo tanto, el factor representa cuántas unidades de combustible se necesitan para producir 1 KWh
// La fórmula es: KWh = cantidad_combustible ÷ factor
// NO es: KWh = cantidad_combustible × factor

/**
 * Convierte energía entre unidades físicas o equivalentes
 *
 * @param {number} value - valor numérico a convertir
 * @param {string} fromUnit - unidad de origen ("liter", "litros", "kg", "m3", "kwh", "mwh", etc.)
 * @param {string} toUnit - unidad destino ("kwh", "mwh")
 * @param {string} fuelType - clave del tipo de combustible
 * @param {boolean} useEquivalence - modo de conversión:
 *   - false → conversión física (kWh ↔ MWh directa)
 *   - true  → conversión a MWh equivalentes usando coeficientes por fuente
 * @returns {number} valor convertido
 */
export function convertEnergy2(
  value,
  fromUnit,
  toUnit,
  fuelType,
  useEquivalence = false
) {
  const source = findEnergyFuente(fuelType);
  // console.log(`🔥 ${fuelType}:`, source, fromUnit, toUnit)
  if (!source) return null;

  // ---------------------------
  // Normalización de unidades
  // ---------------------------
  const normalize = (u) =>
    typeof u === "string" ? u.toLowerCase().replace(/\s+/g, "") : null;

  const unitAliases = {
    kwh: "kwh",
    kilowatthour: "kwh",
    kilowatthours: "kwh",
    mwh: "mwh",
    megawatthour: "mwh",
    megawatthours: "mwh",
    l: "litros",
    lt: "litros",
    litres: "litros",
    liters: "litros",
    liter: "litros",
    litros: "litros",
    m3: "m3",
    cubicmeter: "m3",
    cubicmeters: "m3",
    kg: "kg",
    kgs: "kg",
    kilogram: "kg",
    kilograms: "kg",
    ton: "ton",
    tn: "ton",
    t: "ton",
    tons: "ton",
    tonnes: "ton",
    ton_corta: "ton",
    ton_metrica: "ton",
  };

  const from = unitAliases[normalize(fromUnit)] || normalize(fromUnit);
  const to = unitAliases[normalize(toUnit)] || normalize(toUnit);
  if (!from || !to) return null;

  if (from === to) return value;

  // ===========================
  // 🔹 EQUIVALENCIA ACTIVADA
  // ===========================
  if (useEquivalence) {
    // Solo tiene sentido devolver MWh en modo equivalencia
    if (to !== "mwh") {
      console.warn("convertEnergy2: Equivalence mode solo permite salida en MWh");
      return null;
    }

    const factorMWh = CONVERSION_FACTORS_TO_MWH[source];
    if (factorMWh === undefined) return null;

    let result;

    // Fuentes con factor por litro — si la entrada es m3, convertir a L primero (1 m3 = 1000 L)
    const perLiterSources = ["diesel", "biodiesel", "gasoline", "biofuel", "heavy_fuel_oil", "light_fuel_oil", "glp_l"];
    const m3ToLiterFactor = (from === "m3" && perLiterSources.includes(source)) ? 1000 : 1;

    // kWh → MWh equiv (usando factor de conversión)
    if (from === "kwh") {
      result = value * factorMWh;
      return result;
    }

    // Unidad física → MWh equiv
    if (from !== "kwh" && from !== "mwh") {
      result = value * m3ToLiterFactor * factorMWh;
      return result;
    }

    // MWh físico → MWh equiv (ajuste por factor)
    if (from === "mwh") {
      result = value * (factorMWh / 0.001);
      return result;
    }
  }

  // ===========================
  // 🔹 CONVERSIÓN FÍSICA (default)
  // ===========================

  // Conversión directa energética (kWh ↔ MWh)
  if (from === "kwh" && to === "mwh") {
    return value * 0.001;
  }
  if (from === "mwh" && to === "kwh") {
    return value * 1000;
  }

  // Fuentes con factor por litro — si la entrada es m3, convertir a L primero (1 m3 = 1000 L)
  const perLiterSourcesPhys = ["diesel", "biodiesel", "gasoline", "biofuel", "heavy_fuel_oil", "light_fuel_oil", "glp_l"];
  const m3ToLiterFactorPhys = (from === "m3" && perLiterSourcesPhys.includes(source)) ? 1000 : 1;

  // Unidad física → kWh
  if (to === "kwh" && from !== "kwh" && from !== "mwh") {
    const factorKWh = CONVERSION_FACTORS_TO_KWH[source];
    if (factorKWh !== undefined) {
      return value * m3ToLiterFactorPhys * factorKWh;
    }
  }

  // Unidad física → MWh (via kWh)
  if (to === "mwh" && from !== "kwh" && from !== "mwh") {
    const factorKWh = CONVERSION_FACTORS_TO_KWH[source];
    if (factorKWh !== undefined) {
      return value * m3ToLiterFactorPhys * factorKWh * 0.001;
    }
  }

  // Fallback: usar función antigua si no se encontró conversión
  return convertEnergy2Old(value, fromUnit, toUnit, fuelType);
}

/**
 * ⚠️ FUNCIÓN ANTERIOR (comentada como backup)
 * Convert between mass, volume and energy using calorific data
 * @param {number} value - numeric value to convert
 * @param {string} fromUnit - source unit ("liter", "kg", "m3", "kwh", "mwh", "mj", etc.)
 * @param {string} toUnit - target unit
 * @param {string} fuelType - key of the fuel in FUELS
 * @returns {number} converted value
 */
export function convertEnergy2Old(value, fromUnit, toUnit, fuelType) {
  const source = findEnergyFuente(fuelType);
  if (!source) return;

  const fuel = FUELS[source];
  if (!fuel) {
    return;
  }

  // ---- Helper: normalize and alias ----
  const normalize = (u) => {
    if (!u || typeof u !== "string") return null;
    const clean = u.toLowerCase().replace(/\s+/g, "");
    return clean.length > 0 ? clean : null;
  };

  const unitAliases = {
    l: "liter",
    lt: "liter",
    litres: "liter",
    liters: "liter",
    m3: "m3",
    cubicmeter: "m3",
    cubicmeters: "m3",
    kg: "kg",
    kgs: "kg",
    kilogram: "kg",
    kilograms: "kg",
    t: "ton",
    tn: "ton",
    ton: "ton",
    tons: "ton",
    tonnes: "ton",
     ton_corta: "ton",
  ton_metrica: "ton",
    j: "j",
    joule: "j",
    joules: "j",
    kj: "kj",
    kilojoule: "kj",
    kilojoules: "kj",
    mj: "mj",
    megajoule: "mj",
    megajoules: "mj",
    gj: "gj",
    gigajoule: "gj",
    gigajoules: "gj",
    kwh: "kwh",
    kilowatthour: "kwh",
    kilowatthours: "kwh",
    mwh: "mwh",
    megawatthour: "mwh",
    megawatthours: "mwh",
    btu: "btu",
    btus: "btu",
    mmbtu: "mmbtu",
    mmbtus: "mmbtu",
  };

  fromUnit = unitAliases[normalize(fromUnit)] || normalize(fromUnit);
  toUnit = unitAliases[normalize(toUnit)] || normalize(toUnit);

  if (
    (fromUnit?.toLowerCase() === "un" || fromUnit?.toLowerCase() === "un.") &&
    (toUnit?.toLowerCase() === "un" || toUnit?.toLowerCase() === "un.")
  ) {
    return value;
  }

  if (!fromUnit || !toUnit) {
    //console.warn("⚠️ Invalid or missing unit(s):", { fromUnit, toUnit });
    return null;
  }

  // ---- Direct physical equivalences ----
  const directEquivalents = {
    "liter->m3": 1 / 1000,
    "m3->liter": 1000,
    "kg->ton": 1 / 1000,
    "ton->kg": 1000,
    "j->kj": 1 / 1000,
    "kj->j": 1000,
    "mj->kj": 1000,
    "kj->mj": 1 / 1000,
    "gj->mj": 1000,
    "mj->gj": 1 / 1000,
    "kwh->wh": 1000,
    "wh->kwh": 1 / 1000,
    "mwh->kwh": 1000,
    "kwh->mwh": 1 / 1000,
  };

  const directKey = `${fromUnit}->${toUnit}`;
  if (directEquivalents[directKey]) {
    return value * directEquivalents[directKey];
  }

  // ---- Step 1: Convert any input to MJ ----
  let energyMJ = 0;
  const { density, calorificValueMJt } = fuel;

  if (ENERGY_FACTORS[fromUnit]) {
    energyMJ = value / ENERGY_FACTORS[fromUnit];
  } else if (["liter", "m3"].includes(fromUnit)) {
    energyMJ = value * density * calorificValueMJt;
  } else if (fromUnit === "kg") {
    energyMJ = (value / 1000) * calorificValueMJt;
  } else if (fromUnit === "ton") {
    energyMJ = value * calorificValueMJt;
  } else {
    //throw new Error(`Unsupported source unit: ${fromUnit}`);
    return;
  }

  // ---- Step 2: Convert MJ to desired unit ----
  let result = 0;
  if (ENERGY_FACTORS[toUnit]) {
    result = energyMJ * ENERGY_FACTORS[toUnit];
  } else if (["liter", "m3"].includes(toUnit)) {
    result = energyMJ / (density * calorificValueMJt);
  } else if (toUnit === "kg") {
    result = (energyMJ / calorificValueMJt) * 1000;
  } else if (toUnit === "ton") {
    result = energyMJ / calorificValueMJt;
  } else {
    //throw new Error(`Unsupported target unit: ${toUnit}`);
    return;
  }

  return result;
}

const conversionesMasa = {
  g: 1,
  kg: 1000,
  lb: 453.592,
  oz: 28.3495,
  "ton (métrica)": 1000000,
  "ton (corta)": 907184.74,
};

const conversionesVolumen = {
  m3: 1,
  l: 1000,
  "US gallons": 264.172,
};

export const conversionesEnergia = {
  MJ: 1,
  kWh: 3.6, // 1 kWh = 3.6 MJ
  GJ: 1000, // 1 GJ = 1000 MJ
  btu: 0.00105506, // 1 BTU = 0.00105506 MJ
  mmbtu: 1055.06, // 1 mmBTU = 1055.06 MJ
  J: 0.000001, // 1 J = 1e-6 MJ
};

export const convertUnitsFinal = (value, unita, unitb, material = "") => {
  try {
    const esMoneda = (unidad) =>
      coins_units.some((moneda) => moneda.value === unidad);

    // Si las unidades de origen y destino son iguales, no hacer conversión
    if (!value) {
      return 0;
    } else {
      if (unita === unitb) {
        return value;
      }

      // Si estamos trabajando con monedas, aplicamos la conversión de divisas
      if (esMoneda(unita) && esMoneda(unitb)) {
        return value;
      }

      // Si no es moneda, intentamos usar la librería 'convert'
      const result = convert(value).from(unita).to(unitb);
      // Si la conversión falla y devuelve NaN, vamos a intentar con la función personalizada
      if (isNaN(result)) {
        //console.log('La librería convert-units no pudo realizar la conversión. Intentando con la función personalizada...');
        const result2 = convertEnergy2(value, unita, unitb, material);

        return result2;
        //return value;
      }
      return result;
    }
  } catch (error) {
    try {
      const result2 = convertEnergy2(value, unita, unitb, material);
      //console.log(unita,unitb,material,result2)
      return result2;
    } catch {
      // Si ocurre un error en la librería o en la función personalizada, lo capturamos
      console.error(`Error de conversión: ${error.message}`);
      return null; // Retornamos null si hay un error
    }
  }
};
